<template>
  <div class="listing-search-criteria">
    <v-container fluid class="pt-0">
      <v-row>
        <v-col md="8">
          <p class="m-0 mb-2 font-size-16 font-weight-600">Search Criteria</p>
        </v-col>
        <v-col md="4" class="text-right">
          <div class="close-btn">
            <v-btn
              fab
              outlined
              x-small
              :disabled="dataLoading"
              elevation="2"
              hide-details
              dense
              color="red lighten-1"
              class="red--background"
              v-on:click="clearSearch('clear')"
            >
              <v-icon dark class="text-white"> mdi-close </v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <ul>
        <template v-if="hasCustomerFilter">
          <li
            class="font-weight-500 font-size-14"
            v-if="
              filterNames.customerName ||
              filterNames.billingName ||
              filterNames.propertyName
            "
          >
            <template v-if="filterNames.customerName">
              <li class="font-weight-500 font-size-14">
                Customer contains
                <span class="font-weight-700">{{
                  filterNames.customerName
                }}</span>
                (or)
              </li>
            </template>
            <template v-if="filterNames.billingName">
              <li class="font-weight-500 font-size-14">
                Billing Location contains
                <span class="font-weight-700">{{
                  filterNames.billingName
                }}</span>
                (or)
              </li>
            </template>
            <template v-if="filterNames.propertyName">
              <li class="font-weight-500 font-size-14">
                Property/Site Location contains
                <span class="font-weight-700">{{
                  filterNames.propertyName
                }}</span>
                (or)
              </li>
            </template>
          </li>
        </template>

        <template v-if="searchParam && !isExcludedField(basicSearchFields)">
          <template v-for="(bparam, bindex) in basicSearchFields">
            <li
              :key="bindex"
              class="font-weight-500 font-size-14"
              v-if="!isExcludedField([bparam])"
            >
              {{ lodash.capitalize(lodash.toLower(getFilterLabel(bparam))) }}
              contains
              <span class="font-weight-700">{{ searchParam }}</span> (or)
            </li>
          </template>
        </template>

        <template v-else-if="!isExcludedListingSearch(listingSearch)">
          <template v-for="(param, index) in listingSearch">
            <li
              v-if="!isExcludedField([index])"
              :key="index"
              class="font-weight-500 font-size-14"
            >
              <template v-if="typeof param == 'object'">
                {{ lodash.capitalize(lodash.lowerCase(index)) }} between
              </template>

              <template
                v-if="typeof param == 'string' && !isExcludedField([index])"
              >
                {{ getLabelNew(index) }}
                contains
              </template>
              <span class="font-weight-700">{{ param }}</span>
              <template v-if="lodash.findLastKey(listingSearch) != index">
                (and)
              </template>
            </li>
          </template>
        </template>
      </ul>
      <v-btn
        text
        :disabled="dataLoading"
        color="cyan"
        v-on:click="advancedSearch"
      >
        Advanced Search <v-icon right>mdi-arrow-right</v-icon>
      </v-btn>
    </v-container>
  </div>
</template>

<script>
import { SearchEventBus } from "@/core/lib/search.lib";
import {
  SET_CUSTOMER_LISTING_FILTER,
  SET_FILTER_DISPLAY_NAMES,
} from "@/core/services/store/customer.module";
import { GET, QUERY } from "@/core/services/store/request.module";
import { mapState } from "vuex";

export default {
  props: {
    dataLoading: {
      type: Boolean,
    },
    pageModule: {
      required: true,
      type: String,
      default: () => {
        return "";
      },
    },
    basicSearchFields: {
      type: Array,
      required: true,
      default: () => {
        return new Array();
      },
    },
    allowedSearchFields: {
      type: Array,
      required: true,
      default: () => {
        return new Array();
      },
    },
  },
  data() {
    return {
      searchParam: null,
      listingSearch: new Object(),
    };
  },
  watch: {
    "$route.query": {
      deep: true,
      immediate: true,
      handler() {
        this.updateFields();
      },
    },
  },
  methods: {
    getLabelNew(field) {
      // if(field=='property_name'){
      //   field="site_location_name";
      // }
      switch (field) {
        case "property_name":
          field = "site_location_name";
          break;
        case "sales_id":
          field = "Sales Representative";
          break;
        case "job_title":
          field = "title";
          break;
      }

      let returnType = this.lodash.capitalize(
        this.lodash
          .lowerCase(
            this.lodash
              .replace(field, "text", "name")
              .replaceAll("[barcode]", " #")
            // .replaceAll(field+"[barcode]", " #")
          )
          .replaceAll("barcode", `${this.pageModule} #`)
          .replaceAll("[", ` `)
          .replaceAll("]", ``)
      );
      if (field == "customer[barcode]") {
        returnType = "Customer #";
      }
      return returnType;
    },
    getFilterLabel(field) {
      //when search function clicks
      let child = [];
      let levelOne = field.split(".");
      let parent = levelOne[0].split("_").join(" ");
      if (levelOne[1]) {
        child.push(levelOne[1].split("_").join(" "));
      }
      if (child.length) {
        let childText = child.join(" ");
        return parent + "[" + childText + "]";
      }

      // console.log(this.pageModule);

      if (this.pageModule == "Invoice") {
        parent = this.lodash
          .replace(parent, "title", "title")
          .replaceAll("title", "title");
      }

      if (
        this.pageModule == "Preventive" ||
        this.pageModule == "Warranty" ||
        this.pageModule == "Equipment"
      ) {
        parent = this.lodash
          .replace(parent, "unique id", "serial no")
          .replaceAll("unique id", "serial no");
      }

      if (this.pageModule == "Site Location") {
        parent = this.lodash
          .replace(parent, "property_name", "site location name")
          .replaceAll("property_name", "site location name")
          .replaceAll("property name", `site location name`);
      }
      if (this.pageModule == "Quotation") {
        parent = this.lodash
          .replace(parent, "job_title", "title")
          .replaceAll("job_title", "title")
          .replaceAll("title", `title`);
      }

      parent = this.lodash
        .replace(parent, "zip_code", "postal code")
        .replaceAll("zip_code", `postal code`)
        .replaceAll("zip code", `postal code`);

      parent = this.lodash.lowerCase(parent);

      const result = this.lodash
        .replace(parent, "text", "name")
        .replaceAll("[barcode]", " #")
        .replaceAll("barcode", `${this.pageModule} #`);

      return result;
    },
    clearSearch() {
      /* this.$emit("clear-customer-filters"); */
      SearchEventBus.$emit("clear-search", true);
    },
    advancedSearch() {
      SearchEventBus.$emit("advanced-search", true);
    },
    updateFields() {
      const _this = this;
      _this.searchParam = null;
      _this.listingSearch = new Object();

      if (
        _this.lodash.isEmpty(_this.$route.query) === false &&
        _this.$route.query.search
      ) {
        _this.searchParam = _this.$route.query.search;
      }

      if (
        _this.lodash.isEmpty(_this.$route.query) === false &&
        !_this.$route.query.search
      ) {
        for (let key in _this.$route.query) {
          if (_this.lodash.includes(_this.allowedSearchFields, key)) {
            const val = _this.$route.query[key];
            if (
              val !== null &&
              val !== undefined &&
              val !== "" &&
              (!_this.lodash.isArray(val) || val.length > 0)
            ) {
              _this.listingSearch[key] = val;
            }
          }
        }
      }
    },

    isExcludedField(fields) {
      const excludedFields = ["customer", "property", "billing"];
      return fields.some((field) =>
        excludedFields.includes(this.lodash.lowerCase(field))
      );
    },

    isExcludedListingSearch(listingSearch) {
      const excludedFields = ["customer", "property", "billing"];
      return Object.keys(listingSearch).every((key) =>
        excludedFields.includes(this.lodash.lowerCase(key))
      );
    },
    async fetchCustomerDetails(customer, billing, property) {
      try {
        const { data } = await this.$store.dispatch(QUERY, {
          url: "filter-customer",
          data: { id: customer },
        });

        const customerData = data?.[0];
        if (!customerData) return;

        this.$store.commit(SET_FILTER_DISPLAY_NAMES, {
          customerName: customerData.display_name || "",
          billingName: "",
          propertyName: "",
        });

        if (billing > 0) {
          await this.fetchBillingDetails(customer, billing);
        }

        if (property > 0) {
          await this.fetchPropertyDetails(customer, property);
        }
      } catch (error) {
        this.logError(error);
      }
    },

    async fetchBillingDetails(customer, billing) {
      try {
        const response = await this.$store.dispatch(GET, {
          url: `filter-billing-location/${customer}`,
        });

        const billingData = response.data?.find((b) => b.id == billing);
        if (billingData) {
          this.$store.commit(SET_FILTER_DISPLAY_NAMES, {
            ...this.$store.state.customer.db_filter_display_names,
            billingName: billingData.text || "",
          });
        }
      } catch (error) {
        this.logError(error);
      }
    },

    async fetchPropertyDetails(customer, property) {
      try {
        const response = await this.$store.dispatch(GET, {
          url: `filter-property-location/${customer}`,
        });

        const propertyData = response.data?.find((p) => p.id == property);
        if (propertyData) {
          this.$store.commit(SET_FILTER_DISPLAY_NAMES, {
            ...this.$store.state.customer.db_filter_display_names,
            propertyName: propertyData.text || "",
          });
        }
      } catch (error) {
        this.logError(error);
      }
    },
  },
  beforeDestroy() {
    this.listingSearch = new Object();
    this.searchParam = null;
  },
  mounted() {
    const { customer, property, billing } = this.$route.query;

    if (
      (customer && customer !== "0") ||
      (property && property !== "0") ||
      (billing && billing !== "0")
    ) {
      this.$store.commit(SET_CUSTOMER_LISTING_FILTER, {
        customer,
        property,
        billing,
      });

      if (customer > 0) {
        this.fetchCustomerDetails(customer, billing, property);
      }
    }
  },

  computed: {
    ...mapState({
      filterNames: (state) => state.customer.db_filter_display_names,
      customerFilter: (state) => state.customer.db_filter_listing,
    }),

    hasCustomerFilter() {
      const routeCustomer = this.$route.query.customer;
      const routeBilling = this.$route.query.billing;
      const routeProperty = this.$route.query.property;

      const storeCustomer = this.customerFilter?.customer;
      const storeBilling = this.customerFilter?.billing;
      const storeProperty = this.customerFilter?.property;

      return (
        this.lodash.isNil(routeCustomer) == false ||
        this.lodash.isNil(routeBilling) == false ||
        this.lodash.isNil(routeProperty) == false ||
        this.lodash.isNil(storeCustomer) ||
        this.lodash.isNil(storeBilling) ||
        this.lodash.isNil(storeProperty)
      );
    },
  },
};
</script>
